import React from "react";
import { I2cButton, I2cIcon } from "@webcomponents/i2cwebcomponents/dist/react";
import { useMutation } from "react-query";
import { toTitleCase } from "../../../../Utils/stringUtls";
import ReviewAttribute from "../../../../Components/SharedComponent/ReviewAttribute/ReviewAttribute";
import ReviewSummarySectionHeading from "../../../../Components/SharedComponent/ReviewSummarySectionHeading/ReviewSummarySectionHeading";
import FilesUploadService from "../../../../Services/FilesUploadService";

const AccountAndInformationOverview = ({ data, type = "debit" }) => {
  let data1 = data?.["0_4"];

  const fileDownload = useMutation({
    mutationFn: async (fileName) => {
      return await FilesUploadService.downloadFile(fileName);
    },
    onSuccess: (data, fileName) => {
      const url = window.URL.createObjectURL(new Blob([data.data]));
      const link = document.createElement("a");
      link.href = url;

      // Extract filename from the path
      const fileNameOnly = fileName.split("/").pop() || "download.pdf";
      link.setAttribute("download", fileNameOnly);

      document.body.appendChild(link);
      link.click();

      // Clean up
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    },
    onError: (e) => {
      console.log("api error");
    },
  });

  const downloadFile = async (fileName) => {
    try {
      await fileDownload.mutate(fileName);
    } catch (error) {
      console.log(error);
    }
  };

  const {
    cp_afi_income_account = "",
    cp_afi_funding_account = "",
    cp_afi_operating_account = "",
    cp_afi_inst_name = "",
    cp_afi_routing_number = "",
    cp_afi_p_contact_name = "",
    cp_afi_p_contact_title = "",
    cp_afi_physical_address = "",
    cp_afi_phone_number = "",
    cp_afi_email = "",
    cp_afi_cpm_pci = "",
    afi_cpm_compliant_file,
  } = data1 ?? {};

  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid" className="review-summary-gap">
        {/* <div
          i2c-grid="12@md"
          className="fw-700 review-summary-sub-heading font-bold"
          style={{ marginTop: "16px" }}
        >
          Account & Financial Information
        </div> */}

        <ReviewSummarySectionHeading title="Account & Financial Information" />

        <div i2c-grid="12@md">
          <div className="fw-700 review-summary-section-heading font-bold">
            Financial Information
          </div>
        </div>

        <ReviewAttribute
          label="Financial Institution Name"
          value={cp_afi_inst_name ? toTitleCase(cp_afi_inst_name) : null}
        />
        <ReviewAttribute
          label="Routing Number"
          value={
            cp_afi_routing_number ? cp_afi_routing_number.toUpperCase() : null
          }
        />
        <ReviewAttribute
          label="Contact Name"
          value={
            cp_afi_p_contact_name ? toTitleCase(cp_afi_p_contact_name) : null
          }
        />
        <ReviewAttribute
          label="Title"
          value={
            cp_afi_p_contact_title ? toTitleCase(cp_afi_p_contact_title) : null
          }
        />
        <ReviewAttribute
          label="Phone Number"
          value={cp_afi_phone_number || null}
        />
        <ReviewAttribute
          label="Email"
          value={cp_afi_email ? cp_afi_email : null}
        />
        <div i2c-grid="12">
          <div className="overview-help-text review-attribute-label mb-4 no-text-wrap">
            Physical Address
          </div>
          <div className="overview-val-text review-text-adaptive">
            {cp_afi_physical_address
              ? toTitleCase(cp_afi_physical_address)
              : "-"}
          </div>
        </div>

        <div i2c-grid="12@md">
          <div className="fw-700 review-summary-section-heading font-bold">
            Account Information
          </div>
        </div>

        <ReviewAttribute
          label="Income Account"
          value={
            cp_afi_income_account ? toTitleCase(cp_afi_income_account) : null
          }
        />
        <ReviewAttribute
          label="Funding Account"
          value={
            cp_afi_funding_account ? toTitleCase(cp_afi_funding_account) : null
          }
        />
        <ReviewAttribute
          label="Operating Account"
          value={
            cp_afi_operating_account
              ? toTitleCase(cp_afi_operating_account)
              : null
          }
        />
        <ReviewAttribute
          label="Is the card program manager PCI compliant?"
          value={cp_afi_cpm_pci ? toTitleCase(cp_afi_cpm_pci) : null}
        />

        {afi_cpm_compliant_file && (
          <div i2c-grid="12@md">
            <ReviewAttribute
              label="PCI Compliant Certificate"
              value={
                <div className="file-listing">
                  <span>{afi_cpm_compliant_file}</span>
                  <I2cButton
                    size="small"
                    variant="link color"
                    onClick={() => {
                      downloadFile(afi_cpm_compliant_file);
                    }}
                  >
                    <I2cIcon
                      slot="prefix"
                      name="linear-document-download"
                      label="download"
                    />
                  </I2cButton>
                </div>
              }
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default AccountAndInformationOverview;
